// Simple CSRF token helper: fetch and cache the token per session
let csrfToken = null;

export async function getCsrfToken() {
  if (csrfToken) return csrfToken;
  const res = await fetch('/api/auth/csrf-token', { method: 'GET', credentials: 'include' });
  if (!res.ok) throw new Error('Failed to get CSRF token');
  const data = await res.json();
  csrfToken = data.csrfToken;
  return csrfToken;
}

export async function withCsrfHeaders(extraHeaders = {}) {
  const token = await getCsrfToken();
  return { 'X-CSRF-Token': token, ...extraHeaders };
}

export function invalidateCsrfToken() {
  csrfToken = null;
}

function isMutating(method = 'GET') {
  const m = String(method || 'GET').toUpperCase();
  return m === 'POST' || m === 'PUT' || m === 'PATCH' || m === 'DELETE';
}

// Fetch with CSRF header for mutating methods, credentials included, and one-time 403 retry after refreshing token.
export async function fetchWithCsrfRetry(url, options = {}) {
  const opts = { ...options };
  const method = String(opts.method || 'GET').toUpperCase();
  const headers = { ...(opts.headers || {}) };

  // For mutating requests, attach CSRF header
  if (isMutating(method)) {
    const token = await getCsrfToken();
    if (!headers['X-CSRF-Token']) headers['X-CSRF-Token'] = token;
  }

  // Always send cookies to support session-based auth
  if (!('credentials' in opts)) opts.credentials = 'include';

  opts.method = method;
  opts.headers = headers;

  let res = await fetch(url, opts);
  if (res.status === 403 && isMutating(method)) {
    // Token might be stale: refresh and retry once
    invalidateCsrfToken();
    const fresh = await getCsrfToken();
    opts.headers['X-CSRF-Token'] = fresh;
    res = await fetch(url, opts);
  }
  return res;
}
